export default __webpack_public_path__ + "static/media/recommendations2.fb97cb34.svg";